import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '.';

export const selectAnchorSections = (state: RootState) => state.anchorSections;

export const selectAnchorSectionIds = createSelector(
  selectAnchorSections,
  (state) => Object.keys(state.sections),
);

export const selectAnchorSectionNavigationOptions = createSelector(
  [selectAnchorSections, (_, id: string) => id],
  (state, id) => state.sections[id],
);

export const selectAnchorSectionIsAnimating = createSelector(
  selectAnchorSections,
  (state) => state.isAnimating,
);
